import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const gettrainermodalstatsSlice = createSlice({
    name: 'trainermodalstats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchtrainermodalstats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchtrainermodalstats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchtrainermodalstats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = gettrainermodalstatsSlice.actions;
export default gettrainermodalstatsSlice.reducer;

export const fetchtrainermodalstats = createAsyncThunk('/HorsemodalForStatisitics/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/Trainerstatsmodal/${id}`);
    const trainerstatsData = res.data;
    return trainerstatsData;
})